import React from "react"
import { Helmet, HelmetProps } from "react-helmet"
import { usePageHidden } from "../../../providers/HiddenPageContext"

// Helmet for a page's title and meta tags, held back while the page is hidden (HiddenPageContext).
const PageHelmet: React.FC<HelmetProps> = props => (usePageHidden() ? null : <Helmet {...props} />)

export default PageHelmet
